import { PackEnrichmentResponse, PackRow } from '../types/apogee';

/** Build enrichment view-model from a pack row (API embeds modrinth/curseforge on list/detail). */
export function enrichmentFromPackRow(pack: Pick<PackRow, 'mpi_id' | 'modrinth' | 'curseforge'>): PackEnrichmentResponse | null {
  if (pack.modrinth === undefined && pack.curseforge === undefined) return null;
  return {
    mpi_id: pack.mpi_id,
    modrinth: pack.modrinth ?? null,
    curseforge: pack.curseforge ?? null,
  };
}

/** Usernames / team names from enrichment `author` fields for partnership prefill. */
export function enrichmentAuthorCandidates(en: PackEnrichmentResponse | null): string[] {
  if (!en) return [];
  const out: string[] = [];
  const pushFrom = (s: string | undefined) => {
    if (!s?.trim()) return;
    for (const part of s.split(',')) {
      const t = part.trim();
      if (!t) continue;
      if (!out.some((x) => x.toLowerCase() === t.toLowerCase())) out.push(t);
    }
  };
  pushFrom(en.modrinth?.author);
  pushFrom(en.curseforge?.author);
  return out;
}

/** Short author line for table/card (both platforms when they differ). */
export function enrichmentAuthorDisplayLine(en: PackEnrichmentResponse | null | undefined): string {
  if (!en) return '';
  const mr = en.modrinth?.author?.trim();
  const cf = en.curseforge?.author?.trim();
  if (mr && cf && mr.toLowerCase() !== cf.toLowerCase()) return `${mr} · ${cf}`;
  return mr || cf || '';
}

/** Lowercase blob for client-side search across enrichment fields. */
export function enrichmentSearchBlob(en: PackEnrichmentResponse | null | undefined): string {
  if (!en) return '';
  return [
    en.modrinth?.author,
    en.modrinth?.description,
    en.modrinth?.name,
    en.curseforge?.author,
    en.curseforge?.description,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}
